module.exports = __webpack_public_path__ + "static/media/arrowright.5b31ae35.svg";